import { useEffect, useRef } from "react";
import { useLocation } from "wouter";

export default function About() {
  const [location] = useLocation();
  const aboutBandRef = useRef<HTMLDivElement>(null);
  const musicalDirectorRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Handle hash-based navigation
    if (location.includes('#')) {
      const hash = location.split('#')[1];
      
      if (hash === 'about-band' && aboutBandRef.current) {
        aboutBandRef.current.scrollIntoView({ behavior: 'smooth' });
      } else if (hash === 'musical-director' && musicalDirectorRef.current) {
        musicalDirectorRef.current.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  return (
    <>
      {/* About the Band Section */}
      <div id="about-band" ref={aboutBandRef} className="py-16">
        <div className="container mx-auto px-4">
          <h2 className="font-['Playfair_Display'] text-4xl text-center mb-16 text-[#4A1D6E]">About the Band</h2>
          
          <div className="flex flex-col md:flex-row items-center max-w-6xl mx-auto">
            <div className="md:w-1/2 mb-8 md:mb-0 md:pr-8">
              <img 
                src="https://images.unsplash.com/photo-1460723237483-7a6dc9d0b212?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1000&q=80" 
                alt="Clyde Wind Ensemble performing" 
                className="w-full h-auto rounded-lg shadow-lg"
              />
            </div>
            
            <div className="md:w-1/2">
              <div className="prose prose-lg max-w-none">
                <p className="mb-4">
                  The band was founded in September 2009 by their conductor Diane McCrory with the aim of promoting lifelong learning in music in the West of Scotland. Clyde Wind Ensemble (CWE) gave their inaugural concert six months later which was a resounding success. Later that year the band participated in their first National Concert Band Festival (NCBF) and were awarded Gold.
                </p>
                
                <p className="mb-4">
                  In addition to participating in festivals, CWE give regular concerts throughout the year with a focus on raising money for charitable causes. Conscious of their commitment to the community and desire to promote music to children and young people, CWE undertook their first free Children's Concert in May 2024. The concert was greatly received within the community and will now be an annual event along with their regular Christmas Concert.
                </p>
                
                <p className="mb-4">
                  The band welcomes players of all ages and consists of musicians from secondary school age to retirees, amateurs and professionals alike. They are happy to hear from prospective players who are interested in playing a varied and challenging repertoire, in an inclusive and friendly concert band.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Musical Director Section */}
      <div id="musical-director" ref={musicalDirectorRef} className="bg-[#F8F8F8] py-16">
        <div className="container mx-auto px-4">
          <h2 className="font-['Playfair_Display'] text-4xl text-center mb-16 text-[#4A1D6E]">Musical Director</h2>
          
          <div className="flex flex-col md:flex-row items-center max-w-4xl mx-auto">
            <div className="md:w-2/5 mb-8 md:mb-0">
              <div className="rounded-full overflow-hidden w-64 h-64 mx-auto border-4 border-[#D4AF37] shadow-xl">
                <img 
                  src="https://images.unsplash.com/photo-1532123675048-773bd75df1b4?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=500&q=80" 
                  alt="Diane McCrory, Musical Director" 
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            
            <div className="md:w-3/5 md:pl-12">
              <h3 className="font-['Playfair_Display'] text-3xl mb-4 text-[#4A1D6E]">Diane McCrory</h3>
              <div className="prose prose-lg max-w-none">
                <p className="text-gray-600 mb-4">
                  As the founder and Musical Director of Clyde Wind Ensemble, Diane McCrory brings a wealth of experience and passion to the band.
                </p>
                <p className="text-gray-600 mb-4">
                  [Bio content to be added once received from Diane]
                </p>
                <p className="text-gray-600">
                  Under her direction, the ensemble has achieved Gold awards at multiple National Concert Band Festivals and continues to grow in both repertoire and membership.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
